module.exports = __webpack_public_path__ + "img/icon-round-win.4e9ef195.png";